module.exports = __webpack_public_path__ + "img/top_image3.9e57d3f0.png";